import {Inject, Injectable} from '@angular/core';
import {from, Observable} from 'rxjs';
import {ThemeService} from './theme.service';
import {SETTINGS} from '../models/settings/settings';
import {CoreSettings} from '../models/settings/core.settings';
import {DOCUMENT} from '@angular/common';
import {UiConfigService} from './ui-config.service';
import {ErrorService} from './error.service';


@Injectable()
export class StyleService {

  constructor(@Inject(DOCUMENT) private _document: Document,
              @Inject(SETTINGS) private _settings: CoreSettings,
              private _uiConfigService: UiConfigService, private _themeService: ThemeService, private _errorService: ErrorService) {
  }

  public loadStyles(): Observable<boolean> {
    const globalColor = this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-primary');
    const publicStyle = this._document.getElementById('lv-antragsannahme-public-styles');
    return new Observable(observer => {

      if (!!globalColor && !publicStyle) {
        observer.next(true);
      } else {
        const style = this._document.createElement('link');
        style.id = 'lv-antragsannahme-styles';
        if (!!this._uiConfigService.settings.styles_css_name) {
          if (this._uiConfigService.settings.styles_css_name === '$STYLES_CSS_NAME') {
            this._errorService.pushErrorMessage('Die Variable $STYLES_CSS_NAME wurde nicht ersetzt.');
          }
          style.href = this._settings.app_root_url + this._uiConfigService.settings.styles_css_name;
        } else {
          style.href = this._settings.app_root_url + 'styles.css';
        }
        style.rel = 'stylesheet';
        this._document.head.appendChild(style).onload = () => {
          if (!!publicStyle) {
            const newPublicStyle = this._document.createElement('link');
            newPublicStyle.id = publicStyle.id;
            newPublicStyle.href = publicStyle.getAttribute('href');
            newPublicStyle.rel = 'stylesheet';
            this._document.head.appendChild(newPublicStyle).onload = () => {
              observer.next(true);
            };
          } else {
            observer.next(true);
          }
        };
      }
    });
  }
}
